import { render } from "./TagList.vue?vue&type=template&id=0a9822ca&scoped=true&ts=true"
import script from "./TagList.vue?vue&type=script&lang=ts"
export * from "./TagList.vue?vue&type=script&lang=ts"

import "./TagList.vue?vue&type=style&index=0&id=0a9822ca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a9822ca"]])

export default __exports__